import CheckIcon from '@mui/icons-material/Check';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress/CircularProgress';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { confirmEnrollment } from '../../services/EnrollmentService';

export const ConfirmEnrollment = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [loading, setLoading] = useState<boolean>(true);
  const [message, setMessage] = useState<string>('Trwa potwierdzanie rejestracji...');
  const [success, setSuccess] = useState<boolean>();

  useEffect(() => {
    if (token !== null) {
      confirmEnrollment(token)
        .then((result) => {
          setSuccess(true);
          setMessage('Rejestracja zakończona sukcesem!');
        })
        .catch((error) => {
          setSuccess(false);
          setMessage('Wystąpił problem z potwierdzeniem rejestracji.');
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [token]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '50vh',
          gap: 2,
        }}
      >
        {loading ? (
          <CircularProgress />
        ) : success ? (
          <CheckIcon color="success" fontSize="large" />
        ) : (
          <ErrorOutlineIcon color="error" fontSize="large" />
        )}
        <Typography variant="h6">{message}</Typography>
        {!loading && (
          <Typography variant="body2">
            {success
              ? 'Możesz teraz edytować skład zarejestrowanej drużyny.'
              : 'Spróbuj wczytać link jeszcze raz za kilka minut.'}
          </Typography>
        )}
      </Box>
    </>
  );
};
